import React, { useState, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { updateUserDataAction } from '../../store/actions/actionsMain';
import { useDispatch, useSelector } from 'react-redux';
import UpdateImagePortrait from './UpdateImagePortrait';
import { bucketlink1 } from '../../config/fire-conf';
import { checkUsername } from '../../helpers/regex';
import { firebaseAuthFunc } from '../../config/firebaseAuth';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { deleteUser, updateProfile } from 'firebase/auth';
import { firebaseStorage } from '../../config/firebaseStorage';
import { ref, uploadBytes } from 'firebase/storage';
import apiConfig from '../../config/apiConfig';
import { updatePassword, updateEmail } from 'firebase/auth';
// import router from 'next/router'
import {
  collection,
  getDocs,
  setDoc,
  doc,
  query,
  where,
  writeBatch,
} from '@firebase/firestore/lite';
// import { getDocs } from '@firebase/firestore/dist/lite'
import { getwalletBal } from '../../services/common-query';
import { walletID } from '../../config/fire-conf';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DynamicDialog(props) {
  const [userNameField, setuserNameField] = useState('');
  const [loading, setloading] = useState(false);
  const [emailField, setemailField] = useState('');
  const [ucurrentPasswordField, setucurrentPasswordField] = useState('');
  const [unewPasswordField, setunewPasswordField] = useState('');
  const [imageFile, setimageFile] = useState([]);
  const [amountField, setamountField] = useState('');
  const [addressField, setaddressField] = useState('');
  const dispatch = useDispatch();
  const router = useRouter();
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const toastId = useRef(null);

  const handleClose = () => {
    props.setdialogState(false);
    // setemailField('')
    setucurrentPasswordField('');
    setimageFile([]);
  };

  const updateUsername = async () => {
    setloading(true);
    const { error, errorMessage } = checkUsername(userNameField, 'Username');

    if (error) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(errorMessage, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      setloading(false);
      return;
    }
    // checking for duplicates
    let dataQuery = query(
      collection(firebaseFireStore, 'MusicArtUsernames'),
      where('userName', '==', userNameField.toLowerCase()),
    );
    let dataRef = await getDocs(dataQuery);
    if (!dataRef.empty) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error('Username already exists.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      console.log('come here');
      setloading(false);
      return;
    }
    const updateUser = firebaseAuthFunc.currentUser;
    console.log(updateUser, 'mmoishere');
    setDoc(doc(firebaseFireStore, 'MusicArtUsernames', updateUser.uid), {
      userName: userNameField.toLowerCase(),
      userNameDisplay: userNameField,
    });
    updateProfile(updateUser, {
      displayName: userNameField,
    })
      .then(() => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success('Username updated Successfully.', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        setloading(false);
        handleClose();
        //updating redux store
        let updatedObj = { ...userDataRedux };
        updatedObj.displayName = userNameField;
        dispatch(updateUserDataAction(updatedObj));
        setuserNameField('');
      })
      .catch(function (error) {
        console.log(error, 'errorerror');
        const errorMessage = error.message;
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(errorMessage, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        setloading(false);
      });
  };

  const updateUserEmail = () => {
    setloading(true);

    //signning the user
    signInWithEmailAndPassword(
      firebaseAuthFunc,
      props.userEmail,
      ucurrentPasswordField,
    )
      .then(() => {
        //updating email
        const user = firebaseAuthFunc.currentUser;
        return updateEmail(user, emailField);
      })
      .then(async () => {
        const sellerLDataRef = doc(
          firebaseFireStore,
          'musicartSellerEmails',
          userDataRedux.uid,
        );

        const batch = writeBatch(firebaseFireStore);
        batch.update(sellerLDataRef, {
          email: emailField,
        });

        await batch.commit();

        // Update successful.
        toast.success('User Email Updated Successfully', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        handleClose();

        //updating redux store
        let updatedObj = { ...userDataRedux };
        updatedObj.email = emailField;
        dispatch(updateUserDataAction(updatedObj));

        setemailField('');
        setucurrentPasswordField('');
      })
      .catch((error) => {
        if (error.message.includes('auth/wrong-password')) {
          toast.error('Please enter the correct current password.', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
        } else {
          toast.error(error.message, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
        }
      });
  };

  const updateUserPassword = () => {
    setloading(true);

    //signning the user

    signInWithEmailAndPassword(
      firebaseAuthFunc,
      props.userEmail,
      ucurrentPasswordField,
    )
      .then(() => {
        const user = firebaseAuthFunc.currentUser;
        return updatePassword(user, unewPasswordField)
          .then(() => {
            toast.success('User Password Updated Successfully', {
              position: 'bottom-left',
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setloading(false);
            handleClose();
            setunewPasswordField('');
            setucurrentPasswordField('');
          })
          .catch((error) => {
            const { message, code } = error;
            let errorMessage = '';
            switch (code) {
              case 'auth/invalid-password':
              case 'auth/weak-password': {
                errorMessage =
                  'The password is too weak. Please choose a strong password with at least 6 characters.';
                break;
              }
              default: {
                errorMessage = message;
                break;
              }
            }
            toast.error(errorMessage, {
              position: 'bottom-left',
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setloading(false);
          });
      })
      .catch((error) => {
        if (error.message.includes('auth/wrong-password')) {
          toast.error('Please enter the correct current password.', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
        } else {
          toast.error(error.message, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
        }
      });
  };

  const deleteUserAccount = () => {
    setloading(true);
    //signning the user

    signInWithEmailAndPassword(
      firebaseAuthFunc,
      props.userEmail,
      ucurrentPasswordField,
    )
      .then(() => {
        //updating email
        var user = firebaseAuthFunc.currentUser;

        return deleteUser(user).then(() => {
          toast.success('User Account Deleted Successfully', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
          handleClose();
          setucurrentPasswordField('');
          dispatch(updateUserDataAction(null));
          router.push('/');
        });
      })
      .catch((error) => {
        toast.error(error.message, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
      });
  };

  const updateUserPhoto = async () => {
    setloading(true);
    if (imageFile[0]) {
      //pushing image to DB
      const modifiedURL = `${bucketlink1}profile_images%2F${props.uid}`;
      const storageRef = ref(firebaseStorage, `profile_images/${props.uid}`);

      await uploadBytes(storageRef, imageFile[0].originFileObj).then(() => {
        //updating redux store
        let updatedObj = { ...userDataRedux };
        updatedObj.photoURL = modifiedURL;
        // adding extra key in "userDataRedux" to resolve the problem
        // of image not getting update on upload
        updatedObj.thumbnailUrl = URL.createObjectURL(
          imageFile[0].originFileObj,
        );
        dispatch(updateUserDataAction(updatedObj));
      });

      let currentuser = firebaseAuthFunc.currentUser;
      await updateProfile(currentuser, {
        photoURL: modifiedURL,
      })
        .then(function () {
          setloading(false);
          handleClose();

          toast.success('Image Uploaded Successfully', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        })
        .catch((error) => {
          setloading(false);
          toast.error('Error Occured!', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
        });
    } else {
      setloading(false);
      toast.error('Please provide Profile Image', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const onWithdraw = async () => {
    try {
      setloading(true);
      if (!Number(amountField)) {
        toast.error('Enter a valid amount', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);

        return null;
      }

      let amountInBSV = Number((Number(amountField) / bsvRate).toFixed(8));
      console.log('bal', userWalletRedux.balance, amountInBSV);
      if (userWalletRedux.balance < amountInBSV) {
        toast.error('Insufficient balance in wallet', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);

        return null;
      }

      let data = {
        dataArray: [
          {
            to: addressField,
            amount: Number(amountInBSV),
            type: 'BSV',
            notes: `sending to ${addressField}`,
          },
        ],
      };

      let transactionRes = await apiConfig('/v1/send', {
        method: 'post',
        data: data,
        header: {
          walletID: '00000000-0000-0000-0000-000000000000',
        },
      });

      console.log('transactionRes', transactionRes);

      if (
        transactionRes &&
        transactionRes.data &&
        transactionRes.data.data &&
        transactionRes.data.data.txIds &&
        transactionRes.data.data.txIds[0]
      ) {
        toast.success('Amount transferred successfully', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        setamountField('');
        setaddressField('');
        setloading(false);
        handleClose();

        //updating wallet balance
        getwalletBal(walletID, dispatch);
      }
    } catch (err) {
      console.log('err', err.message, err.response, err);
      toast.error(err.message, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setloading(false);
    }
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
    >
      <div className="dialog-titlebar-medium">
        <div className="dialog-title-medium">
          {(() => {
            if (props.dialogType === 'export') {
              return 'Backup Your Wallet';
            } else if (props.dialogType === 'update-username') {
              return 'Update UserName';
            } else if (props.dialogType === 'update-email') {
              return 'Update Email';
            } else if (props.dialogType === 'update-password') {
              return 'Update Password';
            } else if (props.dialogType === 'update-account') {
              return 'Delete Account';
            } else if (props.dialogType === 'update-image') {
              return 'Add an account photo';
            } else if (props.dialogType === 'withdraw') {
              return 'Withdraw Amount';
            }
          })()}
        </div>
        <div className="dialog-close-medium">
          <button
            className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
            type="button"
            onClick={handleClose}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <form
        className="bg-blueGray-100"
        onSubmit={(e) => {
          e.preventDefault();
          if (props.dialogType === 'update-username') {
            updateUsername();
          } else if (props.dialogType === 'update-email') {
            updateUserEmail();
          } else if (props.dialogType === 'update-password') {
            updateUserPassword();
          } else if (props.dialogType === 'update-account') {
            deleteUserAccount();
          } else if (props.dialogType === 'update-image') {
            updateUserPhoto();
          } else if (props.dialogType === 'withdraw') {
            onWithdraw();
          }
        }}
      >
        <DialogContent>
          {(() => {
            if (props.dialogType === 'export') {
              return (
                <>
                  <p className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                    Please write down your backup phrase to secure your wallet.
                  </p>
                  <p className="mb-4 text-lg leading-relaxed text-blueGray-700">
                    {props.walletmnemonic ? props.walletmnemonic : '-'}
                  </p>
                </>
              );
            } else if (props.dialogType === 'update-username') {
              return (
                <>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      UserName
                    </label>
                    <input
                      onChange={(e) => {
                        setuserNameField(e.target.value);
                      }}
                      type="text"
                      placeholder="Enter your Display Name"
                      required
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      pattern=".*\S+.*"
                      title="This field is required"
                      value={userNameField}
                    />
                    <span className="helper_text">
                      Choose a username with 6–30 characters. It can contain
                      letters (a-z, A-Z), numbers (0-9), and periods (.).
                    </span>
                  </div>
                </>
              );
            } else if (props.dialogType === 'update-email') {
              return (
                <>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      New Email
                    </label>
                    <input
                      required
                      onChange={(e) => {
                        setemailField(e.target.value);
                      }}
                      type="email"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      defaultValue=""
                      value={emailField}
                      placeholder="Enter your New Email Address"
                    />
                  </div>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Current Password
                    </label>
                    <input
                      required
                      onChange={(e) => {
                        setucurrentPasswordField(e.target.value);
                      }}
                      type="password"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      defaultValue=""
                      value={ucurrentPasswordField}
                      placeholder="Enter your Password"
                    />
                  </div>
                </>
              );
            } else if (props.dialogType === 'update-password') {
              return (
                <>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Current Password
                    </label>
                    <input
                      required
                      onChange={(e) => {
                        setucurrentPasswordField(e.target.value);
                      }}
                      type="password"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      defaultValue=""
                      value={ucurrentPasswordField}
                      placeholder="Enter your Current Password"
                    />
                  </div>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      New Password
                    </label>
                    <input
                      required
                      onChange={(e) => {
                        setunewPasswordField(e.target.value);
                      }}
                      type="password"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      defaultValue=""
                      value={unewPasswordField}
                      placeholder="Enter your New Password"
                    />
                  </div>
                </>
              );
            } else if (props.dialogType === 'update-account') {
              return (
                <>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Current Password
                    </label>
                    <input
                      onChange={(e) => {
                        setucurrentPasswordField(e.target.value);
                      }}
                      type="password"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      defaultValue=""
                      placeholder="Enter your Current Password"
                      required
                    />
                  </div>
                </>
              );
            } else if (props.dialogType === 'update-image') {
              return (
                <UpdateImagePortrait
                  photoUrl={props.photoUrl}
                  imageFile={imageFile}
                  setimageFile={setimageFile}
                />
              );
            } else if (props.dialogType === 'withdraw') {
              return (
                <>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Amount (US$)
                    </label>
                    <input
                      onChange={(e) => setamountField(e.target.value)}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      value={amountField}
                      placeholder="Enter the Amount"
                      required
                    />
                  </div>
                  <div>
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Address
                    </label>
                    <input
                      onChange={(e) => setaddressField(e.target.value)}
                      type="text"
                      className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
                      value={addressField}
                      placeholder="Enter the Wallet Address"
                      required
                      pattern=".*\S+.*"
                      title="This field is required"
                    />
                  </div>
                </>
              );
            }
          })()}
        </DialogContent>
        <DialogActions
          style={{
            marginTop: 10,
            height: 50,
          }}
        >
          <div
            style={{
              minWidth: 100,
              textAlign: 'center',
            }}
          >
            {(() => {
              if (loading) {
                return (
                  <div className="flex justify-center	">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                );
              } else {
                if (props.dialogType === 'export') {
                  return (
                    <button
                      className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                  );
                } else {
                  return (
                    <button
                      className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      {props.dialogType === 'update-account'
                        ? 'Delete'
                        : props.dialogType === 'withdraw'
                        ? 'Confirm'
                        : 'Update'}
                    </button>
                  );
                }
              }
            })()}
          </div>
        </DialogActions>
      </form>
    </Dialog>
  );
}
